import "./styles/ConfirmationPage.css";
import { BiSolidCheckCircle } from "react-icons/bi";
import { SectionTitle } from "../../components/BasicComponents";
import { useTranslation } from "react-i18next";
import "../../localisation/index"
const ConfirmationPage = () => {
  const {t} = useTranslation()
  return (
    <div className="confirmation_page-container">
      {/* <img className="success-icon" src={Success} alt="" /> */}
      <BiSolidCheckCircle className="success-icon" />

      <div className="confirmation-heading">
        <SectionTitle weight="600" size="32px" lineheight="48px">
          {t("confirmation.thanksMsg")}
        </SectionTitle>
      </div>

      <p className="confirmaiton-desc">
        {t("confirmation.activation")}
      </p>
    </div>
  );
};

export default ConfirmationPage;
